module.exports = __webpack_public_path__ + "d97be882e191a71f94d0711ab7cdd0ab.ttf";